/**
 * The "Waiting on people" row's word for where an ask stands, from what the
 * request already carries: "sent" (it went out: sent_at) or "answered ·
 * unread" (answer_unseen). Nothing when neither is known; per-channel
 * delivery ("not delivered") is proposal 2's, not guessed here.
 */
import type { DoorDataRequestRead } from '../../services/qcpDataRequests';
import { askSentWord } from '../../components/portal/caseCourtView';
import styles from './CaseCourtLines.module.css';

export default function AskSentWord({
  request,
}: {
  request: Pick<DoorDataRequestRead, 'status' | 'sent_at' | 'answer_unseen'>;
}) {
  const word = askSentWord(request);
  if (!word) return null;
  return (
    <span className={styles.sent} data-word={word.key} data-testid="ask-sent-word">
      {word.text}
    </span>
  );
}
